export default __webpack_public_path__ + "static/skills-tag-neutral-dark-6f9d9a6c86db05c6c829fc908de55b62.png";